<template>
  <div class="p-4 bg-white shadow sm:rounded">
    <h2 class="text-lg font-semibold tracking-wide text-center text-green-600">
      {{ title }}
    </h2>

    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
};
</script>
